module.exports = __webpack_public_path__ + "static/img/business8.8647454.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business8.jpg
// module id = 91oC
// module chunks = 9